import theme, { FontFamily } from 'src/theme'
import styled from 'styled-components'

interface IWrapperSpanProps {
  variant?: 'normal' | 'bold'
}

const normalStyles = `
    font-family: ${FontFamily.primary};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    font-size: ${theme.fontSizes.medium};
    line-height: 22px;
    color: ${theme.colors.gray9};
`

const boldStyles = `
    font-family: ${FontFamily.primary};
    font-style: normal;
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.large};
    line-height: 24px;
    color: ${theme.colors.gray9};
`

const Wrapper = styled.span<IWrapperSpanProps>`
  ${(props) => (props.variant === 'bold' ? boldStyles : normalStyles)}
`

export { Wrapper }
